import UpdateChackInstrument from "../components/configuration/chack/UpdateChackInstrument";

const UpdateChackInstrumentPage = () => {
    return (
        <UpdateChackInstrument />
    )
}

export default UpdateChackInstrumentPage;   
